import { validateEmail } from '../../util/email';
import getPasswordError from './getPasswordError';

const validateRegistration = registration => {
  const updatedRegistration = JSON.parse(JSON.stringify(registration));
  const errors = {};
  if (typeof registration.name !== 'string' || registration.name === '') {
    errors.name = 'required';
  } else if (registration.name.length < 3) {
    errors.name = 'must be at least 3 characters';
  }
  if (!registration.email || !validateEmail(registration.email)) {
    errors.email = 'a valid email address is required';
  }
  if (getPasswordError(registration.password)) {
    errors.password = getPasswordError(registration.password);
  }
  if (registration.password !== registration.passwordConf) {
    errors.passwordConf = 'passwords don\'t match';
  }
  if (typeof registration.org !== 'string' || registration.org === '') {
    errors.org = 'required';
  } else if (registration.org.length < 3) {
    errors.org = 'must be at least 3 characters';
  }
  updatedRegistration.valid = Object.values(errors).length < 1;
  if (updatedRegistration.valid !== true) {
    updatedRegistration.errors = errors;
  }
  return updatedRegistration;
};

export default validateRegistration;
